export const ReferenzIndustrie = () => {
  return (
    <svg
      //width="37.333405mm"
      //height="26.356344mm"
      version="1.1"
      viewBox="0 0 3270.0245 2952.244"
      xmlns="http://www.w3.org/2000/svg"
      className="navicons"
    >
      <defs></defs>
      <g id="Ebene_x0020_1" transform="translate(-9514.9756,-9326.0158)">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <g id="_1027791192" style={{ fill: '#ffd7c8', fillOpacity: '1' }}>
          <path
            className="fil0"
            d="m 12075,10687 c 2,-1 5,-2 7,-2 22,-4 156,-10 232,-3 24,344 59,668 58,1023 l 8,415 -370,8 c 0,-107 6,-407 -7,-486 -28,-8 -32,-16 -61,-19 l -231,1 7,523 c -71,-1 -33,-8 -69,-20 l -1173,21 c 8,-158 19,-306 20,-468 2,-154 -6,-328 3,-479 39,16 83,46 127,68 43,22 85,41 127,68 92,58 238,186 260,105 19,-67 -61,-270 -46,-295 14,-14 -19,-7 20,-12 14,-2 347,225 374,246 288,228 90,-206 84,-310 l 496,238 c 26,13 55,27 85,43 l 80,40 c 24,126 10,650 45,703 34,14 61,-9 68,-36 5,-20 2,-83 2,-108 -2,-142 -12,-549 -39,-645 -75,-25 -112,-29 -180,-65 z m -2427,1482 c -9,-110 -2,-237 -4,-353 -6,-353 -21,-731 -21,-1076 216,0 440,12 654,4 109,-4 223,3 336,5 106,2 224,2 334,10 l -18,222 c -20,14 -48,-7 -74,43 -20,54 47,230 55,303 l -223,-127 c -99,-52 -191,-117 -217,-130 -81,26 -61,83 -61,178 -1,76 -1,153 -1,229 0,147 -10,310 -4,453 -128,-11 -452,-11 -559,24 l 12,53 c 71,23 525,9 541,-2 l 8,144 z m 2456,-1734 c 133,34 196,-44 202,85 1,25 2,49 -2,71 l -218,14 z m 185,-210 7,136 -185,-11 7,-113 z m -147,-176 c 56,-11 78,6 140,-18 l -1,106 -129,6 c -2,0 -4,-1 -6,-1 -27,-4 -9,-66 -4,-93 z m 331,2073 c 1,-235 -13,-470 -18,-700 -11,-467 -74,-837 -82,-1334 -1,-55 -3,-193 -14,-245 -8,-39 -16,-30 -23,-55 -11,-41 15,-56 -44,-53 -56,2 -168,38 -207,61 -2,78 -3,145 -10,221 -6,57 -8,144 -45,181 18,51 22,-6 6,119 l -37,384 c -14,170 -49,329 -60,503 -61,-17 -372,-173 -445,-210 -72,-36 -73,-67 -144,-9 -12,112 36,218 57,314 -44,-13 -336,-233 -390,-249 -3,-75 39,-295 12,-343 -16,-26 -30,-27 -70,-33 -196,-27 -986,-11 -1252,-18 -26,-1 -70,1 -93,-9 -37,-16 -10,-27 -62,-35 -33,59 -18,107 -16,187 1,71 0,142 1,212 4,158 46,1056 -2,1158 -15,30 -23,29 -19,76 60,39 113,36 192,29 130,-11 39,-24 211,-28 148,-3 311,-1 458,-10 140,-10 305,-10 448,-13 l 813,1 c 23,-1 46,2 68,1 47,0 35,-12 59,-12 l 601,-8 c 142,-2 286,25 419,-6 -2,-42 -12,-48 -28,-71 -48,-8 -97,2 -145,2 -51,0 -90,-6 -139,-8 z"
            id="path7"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 12152,9534 c -193,-21 -186,102 -314,49 -140,-57 -125,76 -290,34 -68,-17 -55,-48 -142,-15 -47,17 -89,32 -148,40 -52,6 -115,4 -163,-10 -113,-32 -65,-85 -61,-97 21,-70 21,-76 76,-110 117,-73 215,20 298,10 61,-7 97,-24 171,-19 80,5 91,24 149,41 38,11 82,-11 158,11 80,23 59,48 131,18 39,-15 114,-15 135,48 z m -982,-204 c -59,10 -123,44 -156,75 -38,35 -68,106 -76,153 -24,145 256,211 470,122 72,-29 85,18 179,23 107,5 125,-44 180,-53 41,-7 90,45 200,13 59,-17 93,-73 174,-43 8,4 107,78 99,-13 -2,-21 -10,-30 -18,-43 -17,-27 -35,-163 -199,-131 -59,12 -26,10 -83,-11 -121,-44 -151,-19 -188,-26 -35,-6 -68,-38 -182,-44 -63,-4 -165,20 -204,8 -64,-18 -115,-44 -196,-30 z"
            id="path9"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 10634,11624 c -26,90 -10,60 -11,149 -1,61 -3,105 7,164 63,33 177,42 267,28 l 12,-342 c -54,-2 -105,0 -158,3 -55,2 -55,-18 -117,-2 z"
            id="path11"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11561,11968 51,-346 -218,-1 -50,2 c 0,0 5,38 5,38 2,18 2,9 0,28 -8,59 9,106 5,176 l -3,103 z"
            id="path13"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 9740,10986 c 109,38 486,-18 658,-5 73,5 156,14 225,-4 10,-101 -97,-75 -186,-80 -190,-9 -428,3 -620,29 -52,7 -72,6 -77,60 z"
            id="path15"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 9791,11319 c 81,37 211,12 306,4 73,-7 249,-3 293,-33 -6,-37 -11,-40 -29,-67 -101,-9 -352,18 -468,33 -62,8 -96,3 -102,63 z"
            id="path17"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 9824,11646 c 7,52 54,55 112,58 56,4 112,1 168,-1 174,-6 252,19 271,-65 -53,-49 -195,-26 -278,-23 -78,4 -213,-5 -273,31 z"
            id="path19"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11240,11743 5,-122 h -223 c 2,21 2,79 10,94 l 134,207 38,47 31,5 c 34,-59 -13,-192 5,-231 z"
            id="path21"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
          <path
            className="fil0"
            d="m 11024,11729 1,238 182,2 c -15,-44 -63,-101 -89,-142 -24,-35 -89,-113 -89,-128 z"
            id="path23"
            style={{ fill: '#ffd7c8', fillOpacity: '1' }}
          />
        </g>
      </g>
    </svg>
  );
};
